import {Swiper, winsize} from './bundle'

class SwiperSlideShow {
    constructor(slider) {
        this.slider = slider
        this.swiperContainer = this.slider.querySelector('.swiper-container')
        // this.controlPrev = this.slider.querySelector('.prev')
        // this.controlNext = this.slider.querySelector('.next')

        this.initEvents()
    }

    initEvents() {
        let slidesPerView = 2.5
        // if(isTablet == 'portrait'){
        //     slidesPerView = 1.5
        // }
        // else if(isTablet == 'landscape' || isIpadPro == 'portrait'){
        //     slidesPerView = 1.7
        // }
        var spaceBetween = winsize.width / 10;
        new Swiper(this.swiperContainer, {
            // loop: true,
            slidesPerView: slidesPerView,
            spaceBetween: spaceBetween,
            // navigation: {
            //   nextEl: this.controlNext,
            //   prevEl: this.controlPrev,
            // },
            onSlideChangeStart: (e) => {
                console.log(e)
            }

        });
    }
}

class SwiperSlideShowMobile {
    constructor(slider, spaceBetween = 10) {
        this.slider = slider
        this.spaceBetween = spaceBetween
        this.swiperContainer = this.slider.querySelector('.swiper-container')
        this.initEvents()
    }

    initEvents() {
        // let slidesPerView = 2.5
        // if(isTablet == 'portrait'){
        //     slidesPerView = 1.5
        // }
        // else if(isTablet == 'landscape' || isIpadPro == 'portrait'){
        //     slidesPerView = 1.7
        // }
        // var spaceBetween = winsize.width / 10;
        new Swiper(this.swiperContainer, {
            slidesPerView: 1.3,
            spaceBetween: this.spaceBetween,
            grabCursor: true,
            speed:800,

        });
    }
}

class SwiperProductFeed{
    constructor(slider) {
        this.slider = slider
        this.swiperContainer = this.slider.querySelector('.swiper-container')

        this.initEvents()
    }

    initEvents() {
        new Swiper(this.swiperContainer, {
            slidesPerView: 4.2,
            // spaceBetween: 10,
            grabCursor: true,
            speed:800,

        });
    }

}

export {SwiperSlideShow, SwiperSlideShowMobile, SwiperProductFeed}